import { gql } from "@apollo/client";

export const GET_ESTIMATED_TIME_ARRIVAL = gql`
 mutation GetJobEstimatedTimeArrival($jobId: String!) {
  getJobEstimatedTimeArrival(jobId: $jobId) {
    duration
    location {
      latitude
      longitude
    }
  }
} `;